'use client';

import Link from 'next/link';

import getPrimaryButtonProps, {
  type Functionality,
} from '@/components/ui/Button/PrimaryButton/PrimaryButtonFunctionality';

const cardButtonClassName =
  'inline-flex items-start justify-start rounded-lg border-2 border-theme-primary bg-transparent px-5 py-2.5 text-base font-normal text-theme-primary transition hover:bg-theme-primary hover:text-white hover:border-theme-primary';

type IconCardButtonProps = {
  content: string;
  link?: string;
  functionality?: Functionality;
  onCardButtonClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
    cardIndex: number,
  ) => void;
  cardIndex?: number;
};

const IconCardButton = ({
  content,
  link,
  functionality,
  onCardButtonClick,
  cardIndex,
}: IconCardButtonProps) => {
  const buttonProps = getPrimaryButtonProps({
    functionality,
    slug: link,
  });
  const href = buttonProps.href ?? link;

  if (!href && !onCardButtonClick) return null;

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ) => {
    if (onCardButtonClick) {
      onCardButtonClick(event, cardIndex ?? -1);
    }
  };

  return (
    <p className="mt-auto pt-6 text-left">
      <Link
        href={href ?? '#'}
        className={cardButtonClassName}
        onClick={handleClick}
      >
        {content}
      </Link>
    </p>
  );
};

export default IconCardButton;
